<template>
    <v-card :loading="loading" elevation="0">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <slot>
            <v-card-title>
                {{ title }}
                <v-spacer></v-spacer>
                <v-btn
                    v-if="hasAddNewButton"
                    color="primary"
                    dark
                    class="ml-2"
                    @click="addNewItem"
                >
                    Adaugare
                </v-btn>
                <v-dialog
                    v-else
                    v-model="dialog"
                    max-width="70vw"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="primary"
                            dark
                            class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            Adaugare
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="form.contract_no"
                                            v-validate="''"
                                            label="Numar contract"
                                            data-vv-as="Numar contract"
                                            :error-messages="errorMessages('contract_no')"
                                            :class="{ 'error--text': hasErrors('contract_no') }"
                                            class="primary--text"
                                            name="contract_no"
                                            data-vv-name="contract_no"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="8">
                                    </v-col>
                                    <v-col cols="3">
                                        <v-date-field
                                            v-model="form.contract_date"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('contract_date')"
                                            :class="{ 'error--text': hasErrors('contract_date') }"
                                            class="primary--text"
                                            name="contract_date"
                                            data-vv-name="contract_date"
                                            label="Data contract"
                                            data-vv-as="Data contract"
                                        ></v-date-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-date-field
                                            v-model="form.start"
                                            :error-messages="errorMessages('start')"
                                            :class="{ 'error--text': hasErrors('start') }"
                                            class="primary--text"
                                            name="start"
                                            data-vv-name="start"
                                            label="Data inceput"
                                            data-vv-as="Data inceput"
                                        ></v-date-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-date-field
                                            v-model="form.end"
                                            :error-messages="errorMessages('end')"
                                            :class="{ 'error--text': hasErrors('end') }"
                                            class="primary--text"
                                            name="end"
                                            data-vv-name="end"
                                            label="Data sfarsit"
                                            data-vv-as="Data sfarsit"
                                        ></v-date-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field
                                            v-model="form.data.duration"
                                            v-validate="'required'"
                                            label="Durata scolarizare (saptamani)"
                                            data-vv-as="Durata scolarizare (saptamani)"
                                            :error-messages="errorMessages('data.duration')"
                                            :class="{ 'error--text': hasErrors('data.duration') }"
                                            class="primary--text"
                                            name="data.duration"
                                            data-vv-name="data.duration"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field
                                            v-model="form.amount"
                                            v-validate="'required'"
                                            label="Taxa scoala de soferi"
                                            data-vv-as="Taxa scoala de soferi"
                                            :error-messages="errorMessages('amount')"
                                            :class="{ 'error--text': hasErrors('amount') }"
                                            class="primary--text"
                                            name="amount"
                                            data-vv-name="amount"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field
                                            v-model="form.data.advance"
                                            v-validate="'required'"
                                            label="Avans perceput"
                                            data-vv-as="Avans perceput"
                                            :error-messages="errorMessages('data.advance')"
                                            :class="{ 'error--text': hasErrors('data.advance') }"
                                            class="primary--text"
                                            name="data.advance"
                                            data-vv-name="data.advance"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-autocomplete
                                            :items="instructors"
                                            item-value="id"
                                            item-text="name"
                                            v-model="form.theory_instructor_id"
                                            label="Instructor legislatie"
                                            data-vv-as="Instructor legislatie"
                                            :error-messages="errorMessages('theory_instructor_id')"
                                            :class="{ 'error--text': hasErrors('theory_instructor_id') }"
                                            class="primary--text"
                                            name="theory_instructor_id"
                                            data-vv-name="theory_instructor_id"
                                            clearable
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-autocomplete
                                            :items="instructors"
                                            item-value="id"
                                            item-text="name"
                                            v-model="form.driving_instructor_id"
                                            label="Instructor conducere"
                                            data-vv-as="Instructor conducere"
                                            :error-messages="errorMessages('driving_instructor_id')"
                                            :class="{ 'error--text': hasErrors('driving_instructor_id') }"
                                            class="primary--text"
                                            name="driving_instructor_id"
                                            data-vv-name="driving_instructor_id"
                                            clearable
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-autocomplete
                                            :items="(new $db.Contract).contractScopes"
                                            v-model="form.category"
                                            label="Categorie"
                                            data-vv-as="Categorie"
                                            v-validate="'required'"
                                            :error-messages="errorMessages('category')"
                                            :class="{ 'error--text': hasErrors('category') }"
                                            class="primary--text"
                                            name="category"
                                            data-vv-name="category"
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field
                                            v-model="form.group"
                                            label="Grupa"
                                            data-vv-as="Grupa"
                                            :error-messages="errorMessages('group')"
                                            :class="{ 'error--text': hasErrors('group') }"
                                            class="primary--text"
                                            name="group"
                                            data-vv-name="group"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field
                                            v-model="form.arr_code"
                                            label="Cod ARR"
                                            data-vv-as="Cod ARR"
                                            :error-messages="errorMessages('arr_code')"
                                            :class="{ 'error--text': hasErrors('arr_code') }"
                                            class="primary--text"
                                            name="arr_code"
                                            data-vv-name="arr_code"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-select
                                            :items="(new $db.Contract).drivingLicenseStatuses"
                                            v-model="form.data.driving_license_status"
                                            label="Permis de conducere"
                                            data-vv-as="Permis de conducere"
                                            :error-messages="errorMessages('data.driving_license_status')"
                                            :class="{ 'error--text': hasErrors('data.driving_license_status') }"
                                            class="primary--text"
                                            name="data.driving_license_status"
                                            data-vv-name="data.driving_license_status"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="3" v-if="['REVOKED_LICENSE', 'AVAILABLE_LICENSE'].indexOf(form.data.driving_license_status) >= 0">
                                        <v-text-field
                                            v-model="form.data.driving_license_categories"
                                            label="Categorii detinute"
                                            data-vv-as="Categorii detinute"
                                            :error-messages="errorMessages('data.driving_license_categories')"
                                            :class="{ 'error--text': hasErrors('data.driving_license_categories') }"
                                            class="primary--text"
                                            name="data.driving_license_categories"
                                            data-vv-name="data.driving_license_categories"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="3" v-if="'REVOKED_LICENSE' === form.data.driving_license_status">
                                        <v-text-field
                                            v-model="form.data.driving_license_revoked"
                                            label="Anul anularii"
                                            data-vv-as="Anul anularii"
                                            :error-messages="errorMessages('data.driving_license_revoked')"
                                            :class="{ 'error--text': hasErrors('data.driving_license_revoked') }"
                                            class="primary--text"
                                            name="data.driving_license_revoked"
                                            data-vv-name="data.driving_license_revoked"
                                        ></v-text-field>
                                    </v-col>
                                    <template v-if="'AVAILABLE_LICENSE' === form.data.driving_license_status">
                                        <v-col cols="3">
                                            <v-text-field
                                                v-model="form.data.driving_license_no"
                                                label="Numar permis"
                                                data-vv-as="Numar permis"
                                                :error-messages="errorMessages('data.driving_license_no')"
                                                :class="{ 'error--text': hasErrors('data.driving_license_no') }"
                                                class="primary--text"
                                                name="data.driving_license_no"
                                                data-vv-name="data.driving_license_no"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-text-field
                                                v-model="form.data.driving_license_emission"
                                                label="Emitent"
                                                data-vv-as="Emitent"
                                                :error-messages="errorMessages('data.driving_license_emission')"
                                                :class="{ 'error--text': hasErrors('data.driving_license_emission') }"
                                                class="primary--text"
                                                name="data.driving_license_emission"
                                                data-vv-name="data.driving_license_emission"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-date-field
                                                v-model="form.data.driving_license_date"
                                                label="Data permis"
                                                data-vv-as="Data permis"
                                                :error-messages="errorMessages('data.driving_license_date')"
                                                :class="{ 'error--text': hasErrors('data.driving_license_date') }"
                                                class="primary--text"
                                                name="data.driving_license_date"
                                                data-vv-name="data.driving_license_date"
                                            ></v-date-field>
                                        </v-col>
                                    </template>
                                    <v-col cols="12">
                                        <v-checkbox
                                            v-model="form.custom_invoice_data"
                                            label="Date de facturare companie"
                                            data-vv-as="Date de facturare companie"
                                            :error-messages="errorMessages('custom_invoice_data')"
                                            :class="{ 'error--text': hasErrors('custom_invoice_data') }"
                                            class="primary--text"
                                            name="custom_invoice_data"
                                            data-vv-name="custom_invoice_data"
                                        ></v-checkbox>
                                    </v-col>
                                    <template v-if="form.custom_invoice_data">
                                        <v-col cols="3">
                                            <v-text-field
                                                v-model="form.data.company_name"
                                                label="Denumire societate / persoana"
                                                data-vv-as="Denumire societate / persoana"
                                                :error-messages="errorMessages('data.company_name')"
                                                :class="{ 'error--text': hasErrors('data.company_name') }"
                                                class="primary--text"
                                                name="data.company_name"
                                                data-vv-name="data.company_name"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-text-field
                                                v-model="form.data.company_vat"
                                                label="CUI / CNP"
                                                data-vv-as="CUI / CNP"
                                                :error-messages="errorMessages('data.company_vat')"
                                                :class="{ 'error--text': hasErrors('data.company_vat') }"
                                                class="primary--text"
                                                name="data.company_vat"
                                                data-vv-name="data.company_vat"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-text-field
                                                v-model="form.data.company_rc"
                                                label="Numar R.C / CNP"
                                                data-vv-as="Numar R.C / CNP"
                                                :error-messages="errorMessages('data.company_rc')"
                                                :class="{ 'error--text': hasErrors('data.company_rc') }"
                                                class="primary--text"
                                                name="data.company_rc"
                                                data-vv-name="data.company_rc"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-text-field
                                                v-model="form.data.company_address"
                                                label="Sediu social / Domiciliu"
                                                data-vv-as="Sediu social / Domiciliu"
                                                :error-messages="errorMessages('data.company_address')"
                                                :class="{ 'error--text': hasErrors('data.company_address') }"
                                                class="primary--text"
                                                name="data.company_address"
                                                data-vv-name="data.company_address"
                                            ></v-text-field>
                                        </v-col>
                                    </template>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="close"
                            >
                                Renuntare
                            </v-btn>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="save"
                            >
                                Salveaza
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                        <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="closeDelete">Anulare</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card-title>
        </slot>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
        >
            <template v-slot:item.driving_instructor_id="{ item }">
                {{ _.get(item, 'driving_instructor.name') }}
            </template>
            <template v-slot:item.theory_instructor_id="{ item }">
                {{ _.get(item, 'theory_instructor.name') }}
            </template>
            <template v-slot:item.contract_date="{ item }">
                {{ new Date(item.contract_date) | date }}
            </template>
            <template v-slot:item.start="{ item }">
                <template v-if="!_.isNil(item.start)">
                    {{ new Date(item.start) | date }}
                </template>
            </template>
            <template v-slot:item.amount="{ item }">
                {{ item.amount | price }}
            </template>
            <template v-slot:item.end="{ item }">
                <template v-if="!_.isNil(item.end)">
                    {{ new Date(item.end) | date }}
                </template>
            </template>
            <template v-slot:item.created_by="{ item }">
                {{ item.created_by.name }}<br/>
                {{ item.updated_by.name }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn
                    outlined
                    small
                    class="mr-2"
                    color="primary"
                    @click="downloadContract(item)"
                >
                    <v-icon>mdi-file-pdf</v-icon>
                    Contract
                </v-btn>
                <v-btn
                    v-if="!_.isNil(item.arr_code)"
                    outlined
                    small
                    class="mr-2"
                    color="primary"
                    @click="downloadFile(item)"
                >
                    <v-icon>mdi-file-pdf</v-icon>
                    Fisa
                </v-btn>
                <v-btn
                    outlined
                    small
                    class="mr-2"
                    color="success"
                    @click="editItem(item)"
                >
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                    outlined
                    small
                    class="mr-2"
                    color="error"
                    @click="deleteItem(item)"
                >
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    import SmartTable from "Components/SmartTable";
    export default {
        extends: SmartTable,
        mixins: [validationError],
        props: {
            contracts: {
                type: Array,
                default () {
                    return []
                }
            },
            customerId: {
                type: [String, Number],
                default () {
                    return undefined
                }
            }
        },
        data: () => ({
            title: 'Contracte',
            loading: true,
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Numar contract', value: 'contract_no' },
                { text: 'Data', value: 'contract_date' },
                { text: 'Categorie', value: 'category' },
                { text: 'Cod ARR', value: 'arr_code' },
                { text: 'Grupa', value: 'group' },
                { text: 'Data inceput', value: 'start' },
                { text: 'Data sfarsit', value: 'end' },
                { text: 'Valoare', value: 'amount' },
                { text: 'Instructor legislatie', value: 'theory_instructor_id' },
                { text: 'Instructor conducere', value: 'driving_instructor_id' },
                { text: 'Adaugat/Creat de', value: 'created_by' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            form: new Form({
                id: null,
                contract_no: null,
                workstation_id: null,
                customer_id: null,
                theory_instructor_id: null,
                driving_instructor_id: null,
                category: null,
                group: null,
                arr_code: null,
                contract_date: null,
                start: null,
                end: null,
                amount: null,
                custom_invoice_data: false,
                data: {
                    duration: null,
                    advance: null,
                    driving_license_status: 'NONE',
                    driving_license_revoked: null,
                    driving_license_categories: null,
                    driving_license_no: null,
                    driving_license_emission: null,
                    driving_license_date: null,
                    company_name: null,
                    company_vat: null,
                    company_rc: null,
                    company_address: null
                },
            }),
            defaultItem: {
                id: null,
                workstation_id: null,
                contract_no: null,
                customer_id: null,
                theory_instructor_id: null,
                driving_instructor_id: null,
                category: null,
                group: null,
                arr_code: null,
                contract_date: null,
                start: null,
                end: null,
                amount: null,
                data: {
                    duration: null,
                    advance: null
                },
            },
            instructors: []
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare contract' : 'Modificare contract'
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
            contracts: {
                handler(val) {
                    this.items = val
                },
                deep: true
            }
        },

        async created () {
            this.instructors = await this.$db.Employee
                .where('active', true)
                .limit(100)
                .get()
                .then(({data}) => data)
            await this.initialize()
            this.loading = false
        },

        methods: {
            initialize(){
                this.items = this.contracts
            },

            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.form = new Form(Object.assign({}, item))
                this.dialogDelete = true
            },

            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                var userModel = await new this.$db.Customer({id: this.customerId});
                new this.$db.Contract({ id: item.id })
                    .for(userModel)
                    .delete()
                    .then(() => {
                        this.$emit('refresh')
                    })
                this.dialogDelete = false
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.form = new Form(Object.assign({}, this.defaultItem))
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.form = new Form(Object.assign({}, this.defaultItem))
                    this.editedIndex = -1
                })
            },

            save () {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;

                var userModel = await new this.$db.Customer({id: this.customerId});

                if (this.id) {
                    model.id = this.id
                }

                new this.$db.Contract(self.form)
                    .for(userModel)
                    .save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                    }).then(() => {
                        this.$emit('refresh')
                        this.close()
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                    });
            },
            downloadContract(item) {
                const downloadEndpoint = new this.$db.Contract({id: item.id}).downloadEndpoint
                this.loading = true
                return window.axios.get(`${downloadEndpoint}/contract`, {
                    responseType: 'blob'
                }).then((response) => {
                    const contentDisposition = this._.get(response, 'headers.content-disposition')
                    const filename = contentDisposition.split("filename=")[1];
                    const downloadUrl = window.URL.createObjectURL(new Blob([response?.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', filename); //any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }).catch((err) => {
                    console.error(err)
                }).finally(() => {
                    this.loading = false
                })
            },
            downloadFile(item) {
                const downloadEndpoint = new this.$db.Contract({id: item.id}).downloadEndpoint
                this.loading = true
                return window.axios.get(`${downloadEndpoint}/file`, {
                    responseType: 'blob'
                }).then((response) => {
                    const contentDisposition = this._.get(response, 'headers.content-disposition')
                    const filename = contentDisposition.split("filename=")[1];
                    const downloadUrl = window.URL.createObjectURL(new Blob([response?.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', filename); //any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }).catch((err) => {
                    console.error(err)
                }).finally(() => {
                    this.loading = false
                })
            }
        },
    };
</script>
